module.exports = function (init) {
    const self = this

    self.loading = true

    console.log('searching for ')
    console.log(self.query)

    const data = {
        activePage: self.pagination.activePage,
        query: self.query,
        init: init,
        orderField: self.orderField,
        orderBy: self.orderBy
    }

    this.$http.post(
        '/' + self.model + '/vueList',
        data,
        {
            before (request) {
                // abort previous request, if exists
                if (this.previousRequest) {
                    console.log('abort previous request')
                    this.previousRequest.abort()
                }
                // set previous request on Vue instance
                this.previousRequest = request
            }
        }
    ).then((response) => {
        console.log(response.body)

        const data = response.body

        self.items = data.items
        self.settings = data.settings
        self.loading = false

        if (init == true) {
            console.log('query get back from list on init')
            console.log(data.settings)

            self.foldoutComponent = data.settings.foldoutComponent

            if (data.settings.query == null) {
                self.query = {}
            } else {
                self.query = data.settings.query
                self.orderField = data.settings.sorting.orderField
                self.orderBy = data.settings.sorting.orderBy
            }
        }

        console.log('query get back from list')
        console.log(data.settings.query)

        self.pagination.numItemsShow = self.items.length

        self.pagination.numItems = data.pagination.numItems
        self.pagination.numPages = data.pagination.numPages
        self.pagination.activePage = data.pagination.activePage
        self.pagination.limitNumPages = self.limitNumPages()
        self.pagination.totalItems = data.pagination.totalItems
    }, (response) => {
        console.log(JSON.stringify(response))
    })
}
